import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Space,
  Table,
} from "antd";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";

import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../admin/pageHeader/pageheader";

function VisitorsDetails() {
  const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [meta, setMeta] = useState<any>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const columns = [
    {
      dataIndex: "visitors_name",
      title: "visitors_name",
    },
    {
      dataIndex: "date",
      title: "date",
    },
    {
      dataIndex: "visitors_email",
      title: "visitors_email",
    },
    {
      dataIndex: "visitors_purpose",
      title: "visitors_purpose",
    },
    {
      dataIndex: "visitors_phone",
      title: "visitors_phone",
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() =>
              navigate(`/Receptionist/Visitors_details/${record?.id}`)
            }
          />
        </Space>
      ),
    },
  ];

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        visitorsId: values.visitorsId,
        type: values.type,
        visitors_name: values.visitors_name,
        date: values.date,
        visitors_email: values.visitors_email,
        visitors_purpose: values.visitors_purpose,
        employee_id: Number(user.id),
        visitors_phone: values.visitors_phone,
        description: values.description,
        altPhone: values.altPhone,
      };

      setIsLoading(true);
      const api = API.CREATE_VISITORS;
      const postRequest: any = await POST(api, obj);
      if (postRequest.status) {
        notification.success({ message: "visitors created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchVisitors = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 10,
      };
      const url = API.LIST_VISITORS;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchVisitors(page, pageSize);
  }, [page, pageSize]);

  const filterVisitors = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        visitors_name: values.visitors_name,
        date: values.date,
      };
      const url = API.FILTER_VISITORS;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <PageHeader>
        {" "}
        <Button
          type="primary"
          onClick={showModal}
          style={{ marginRight: "10px" }}
        >
          Create Visitors
        </Button>
      </PageHeader>
      <Card>
        <Form form={form} onFinish={filterVisitors} layout="vertical">
          <Row gutter={16} align="middle">
            <Col sm={6}>
              <Form.Item name="visitors_name" label=" visitors_name">
                <Input placeholder=" visitors_name" allowClear />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item name="date" label=" date">
                <DatePicker allowClear />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Search
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>

      <Card>
        <Modal
          title="Create Visitors"
          visible={isModalOpen}
          onCancel={handleCancel}
          width={1000}
          footer={false}
        >
          <Form form={form} onFinish={submitHandler} layout="vertical">
            <Row gutter={16}>
              <Col sm={6}>
                <Form.Item
                  name="visitorsId"
                  label=" visitorsId"
                  rules={[{ required: true, message: "Enter visitorsId" }]}
                >
                  <Input placeholder=" visitorsId" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="type"
                  label="type"
                  rules={[{ required: true, message: "Enter type" }]}
                >
                  <Input placeholder="type" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="visitors_name"
                  label="visitors_name"
                  rules={[{ required: true, message: "Enter visitors_name" }]}
                >
                  <Input placeholder="visitors_name" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item
                  name="date"
                  label="date"
                  rules={[{ required: true, message: "Select date" }]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item
                  name="visitors_purpose"
                  label="visitors_purpose"
                  rules={[
                    { required: true, message: "Enter visitors_purpose" },
                  ]}
                >
                  <Input.TextArea placeholder="visitors_purpose" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item name="visitors_phone" label="visitors_phone">
                  <Input placeholder="visitors_phone" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item name="altPhone" label="altPhone">
                  <Input placeholder="altPhone" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="description" label="description">
                  <Input.TextArea placeholder="description" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="visitors_email"
                  label="visitors_email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Enter visitors_name",
                    },
                  ]}
                >
                  <Input type="email" placeholder="visitors_email" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Create visitors
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
        <Table
          columns={columns}
          dataSource={data}
          loading={isLoading}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total || 0,
            onChange: (page, pageSize) => {
              setPage(page);
              setPageSize(pageSize);
              fetchVisitors(page, pageSize);
            },
          }}
        />
      </Card>
    </div>
  );
}

export default VisitorsDetails;
